import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import IndexApp from "../../Components/IndexApp";
import { getActiveBrandConfig } from "../../config/environment.config";
import { isTeachrAccountActive } from "../../Utils/Function";
import { DV2 } from "../../App/DeclarationV2/theme";
import { Notice, TextLink } from "../../App/DeclarationV2/layout/Ui";
import DraftEdit from "../../App/BrouillonsV2/DraftEdit";
import { useDraft } from "../../App/BrouillonsV2/useDrafts";
import { draftsPath } from "../../App/BrouillonsV2/paths";

/**
 * Modifier un brouillon, route `/{marque}/tableau-de-bord/{prestation}/brouillons/:draftId`
 * (maquettes 1h et 2h) : une page à la place de la modale de l'onglet
 * existant, qui sert aussi à corriger un refus de la vérification.
 */
const BrouillonEditV2Page = () => {
    const navigate = useNavigate();
    const { draftId } = useParams<{ draftId: string }>();
    const teachr = useSelector((s: any) => s.user.currentUser.teachr);
    const id = draftId ? parseInt(draftId, 10) : null;
    const { draft, loading, failed, reload } = useDraft(teachr, Number.isFinite(id as number) ? id : null);

    useEffect(() => {
        if (teachr?.id && !isTeachrAccountActive(teachr)) {
            navigate(`/${getActiveBrandConfig()}/profile/complete`, { replace: true });
        }
    }, [teachr, navigate]);

    const body = () => {
        if (draft) return <DraftEdit key={draft.id} draft={draft} teachr={teachr} />;
        if (loading) {
            return (
                <div style={{ padding: 48, textAlign: "center", color: DV2.muted, fontSize: 14 }}>
                    <CircularProgress size={18} style={{ marginRight: 8, verticalAlign: "middle" }} /> Chargement du brouillon…
                </div>
            );
        }
        return (
            <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 py-8">
                <Notice tone={failed ? "danger" : "info"} action={<TextLink label={failed ? "Réessayer" : "Voir la déclaration rapide"} onClick={() => (failed ? reload() : navigate(draftsPath()))} />}>
                    {failed ? "Le brouillon n'a pas pu être chargé." : "Ce brouillon n'existe plus : il a été déclaré ou supprimé."}
                </Notice>
            </div>
        );
    };

    return (
        <IndexApp
            navBar={{ index: 1 }}
            teachr={teachr}
            component={
                <main style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)" }}>
                    {teachr?.id ? body() : null}
                </main>
            }
        />
    );
};

export default BrouillonEditV2Page;
